export default "__VITE_ASSET__D6q5ICPw__"